
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";

const Wrapper = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  minWidth: "100vw",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(4),
  textAlign: "center",
  backgroundColor: theme.palette.background.default,
}));

const Logo = styled("img")(({ theme }) => ({
  marginBottom: 20,
  height: 100,
}));

const REDIRECT_URL = "https://portal.wca.com";
const REDIRECT_DELAY_MS = 10000;

export default function ReroutePage({ onRetry }) {
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_DELAY_MS / 1000);

  useEffect(() => {
    // Countdown interval (updates every second)
    const intervalId = setInterval(() => {
      setSecondsLeft((s) => Math.max(s - 1, 0));
    }, 1000);

    // Redirect after delay
    const timeoutId = setTimeout(() => {
      // Use replace() so the back button doesn't return to the decommissioned page
      window.location.replace(REDIRECT_URL);
    }, REDIRECT_DELAY_MS);

    // Cleanup on unmount
    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Wrapper>
      <Logo src={"WCA-HeaderLogo.png"} alt={"WCA logo"} />
      <Typography variant="h3" gutterBottom>
        Rerouting to portal.wca.com
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mb: 1 }}>
        portal.wcaoem.com is being decommissioned. Please visit our new portal at{" "}
        <strong>portal.wca.com</strong> to continue accessing your account and services.
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 3 }}>
        Redirecting in {secondsLeft} second{secondsLeft === 1 ? "" : "s"}…
      </Typography>

      {/* Immediate navigation option */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => window.location.replace(REDIRECT_URL)}
        aria-label="Go to portal.wca.com now"
      >
        Go to portal.wca.com
      </Button>

    </Wrapper>
  );
}
